// extracted by mini-css-extract-plugin
module.exports =  {"container":"yHbFZY","main":"RYdFB5","viewer_classic":"RJXC5v","viewerClassic":"RJXC5v","viewer_x":"D9PFGs","viewerX":"D9PFGs","toastContainer":"pckntF"};